/*eslint-disable */
define(function (require) {
    'use strict';

    var initialiseChannelSelector = require('./channel-selector');

    initialiseChannelSelector();
});
